import { useEffect } from 'react';
import { useVirtualKeyboardInset } from './useVirtualKeyboardInset';

/**
 * Publishes the OS keyboard's covered strip as `--virtual-keyboard-height` so
 * plain CSS (which cannot read `visualViewport`) can pad above it.
 *
 * Only needed for engines that resize the VISUAL viewport only (iOS Safari and
 * its PWAs). Where `interactive-widget=resizes-content` is honored the layout
 * viewport shrinks on its own, the inset is 0, and the var stays unset.
 */
export function useKeyboardInsetVar(): void {
  const inset = useVirtualKeyboardInset();

  useEffect(() => {
    const root = document.documentElement;
    if (inset > 0) {
      root.style.setProperty('--virtual-keyboard-height', `${inset}px`);
    } else {
      root.style.removeProperty('--virtual-keyboard-height');
    }
    return () => {
      root.style.removeProperty('--virtual-keyboard-height');
    };
  }, [inset]);
}
